import React, { useEffect, useState } from 'react';
import PcModelPanelPrintsImagesView from '../PcModelPanelPrintsImagesView';
import PcModelPanelPrintsOptionsList from '../PcModelPanelPrintsOptionsList';

const PcModelPanelPrints = ({ options, panelPrintImages, panelPrintSubGroups, suggestedOptionId }) => {
  const [selectedOption, setSelectedOption] = useState(options[0]);

  useEffect(() => {
    setSelectedOption(options[0]);
  }, []);

  const handleSelectOption = (option) => {
    setSelectedOption(option);
  };

  const optionSku = selectedOption.sku;

  // console.log(selectedOption.sku);

  return (
    <>
      <div className="panel-prints-wrapper" id={`group-type-panel_print`}>
        <PcModelPanelPrintsImagesView
          panelPrintImages={panelPrintImages}
          sku={selectedOption.sku}
        />
        <PcModelPanelPrintsOptionsList
          options={options}
          handleSelectOption={handleSelectOption}
          selectedOption={selectedOption}
          panelPrintSubGroups={panelPrintSubGroups}
          suggestedOptionId={suggestedOptionId}
        />
      </div>
      <style jsx>{`
        .panel-prints-wrapper {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          margin-top: -72px;
          padding-top: 72px;
        }
        @media (max-width: 900px) {
          .panel-prints-wrapper {
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin-bottom: 35px;
          }
        }
      `}</style>
    </>
  );
};

export default PcModelPanelPrints;
